var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var ViewTitle = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  margin-top: .5rem;\n  margin-bottom: .5rem;\n"], ["\n  font-size: ", ";\n  margin-top: .5rem;\n  margin-bottom: .5rem;\n"])), function (props) { return props.theme.type.sizes.h4; });
export default ViewTitle;
var templateObject_1;
